import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Modal, Form, Input, Row, Col, Select, message, AutoComplete, Spin } from 'antd'; // Divider, Space, Checkbox
import PropTypes from 'prop-types';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import DeleteConnectionPopup from './DeleteConnectionPopup';
import { setEditCall, setExPoCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { getTitle, getNoofEmployee, getAnnualRevenue, IndustryData, getAllUsersData, getLeadStatusData, getCountryData, getLeadsourceData, getCityData, getStateData, getRating, getTriggerFiledforEntity, getSeniorityLevelData } from '../../../Api/Services/CommonApiService'
import { FetchAllLead, massUpdateLead, massDeleteLeads, convertLeadToContact } from '../../../Api/Services/LeadApiServices'
import { FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Data from '../MassupdateJson/InLineEditFields.json'
// import Party from '../../../static/img/defaultImages/Party.gif'
import { ChangeOwnerIcon, ConvertIcon, SaveIcon, CancelIcon, DeleteIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

const Popup = ({ popup, setPopup, GetAll, popupType, values, action, setStates, assignOwner, pageType, successMessage }) => {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const history = useHistory();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const ProfileData = localData.profile
    const profile = ProfileData
    const [open, setOpen] = useState(false)
    // const [data, setData] = useState()
    const [title, setTitle] = useState([])
    const [fieldValue, setFieldValue] = useState(1)
    const [rating, SetRating] = useState([])
    // const [showAll, setShowAll] = useState(false);
    // const [show, setShow] = useState(false);
    const [leadStatus, setLeadStatus] = useState([])
    const [leadsource, setLeadSource] = useState([])
    const [users, setUsers] = useState([])
    const [industryData, setIndustryData] = useState([])
    const [noofemployee, setNoofemployee] = useState([])
    const [field1, setField1] = useState()
    const [revenue, setRevenue] = useState([])
    const [errorData, setErrorData] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [allCountry, setAllCountry] = useState([])
    const [uiReady, setUiReady] = useState(false)
    const [stateData, setStateData] = useState([])
    const [cityData, setCityData] = useState([])
    const [account2, setAccount2] = useState([])
    const [seniority, setSeniority] = useState([])
    const [tagType, setTagType] = useState("Add")
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [editAttributes, setEditAttributes] = useState([])
    const [selectBoxes, setSelectBoxes] = useState([{ editedField: "title", editedValue: null }]);
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    // const initialItemsToShowAll = 3;
    // const itemsToShowAll = showAll ? data.error.length : initialItemsToShowAll;
    // const initialItemsToShow = 3;
    // const itemsToShow = show ? data.success.length : initialItemsToShow;
    const fieldsToValidate = ['primaryEmail', 'secondaryEmail', 'email', 'mobile', 'assitantContactNumber', 'phone', 'website'];
    const isValidEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };
    const isValidPhoneNumber = (phoneNumber) => {
        const phonePattern = /^[0-9+-]+$/;
        return phonePattern.test(phoneNumber);
    };
    const isValidWebsite = (website) => {
        const websiteRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return websiteRegex.test(website);
    };
    const validateQuery = (query) => {
        if (!fieldsToValidate.includes(query.editedField)) {
            return true;
        }
        switch (query.editedField) {
            case 'primaryEmail':
            case 'secondaryEmail':
            case 'email':
                if (!isValidEmail(query.editedValue)) {
                    message.error(`Please enter a valid email address.`);
                    return false;
                }
                break;
            case 'mobile':
            case 'assitantContactNumber':
            case 'phone':
                if (!isValidPhoneNumber(query.editedValue)) {
                    message.error(`Invalid phone/mobile number`);
                    return false;
                }
                break;
            case 'website':
                if (!isValidWebsite(query.editedValue)) {
                    message.error(`Please enter a valid website url.`);
                    return false;
                }
                break;
            default:
                return false;
        }
        return true;
    };
    const validateQueryData = (queryData) => {
        return queryData.every(validateQuery);
    };
    function RequiredValidity(queryData) {
        for (let i = 0; i < queryData.length; i += 1) {
            const query = queryData[i];
            if (!query.editedField) {
                return { isValid: false, message: 'Incomplete field(s)' };
            }
            if (query.visible !== "No") {
                if (!(query.editedField === "tags" && tagType === "Clear") &&
                    (query.editedValue === undefined || query.editedValue === null || (typeof query.editedValue === 'string' && query.editedValue.trim() === ''))
                ) {
                    return { isValid: false, message: 'Incomplete field(s)' };
                }
            }
        }
        return { isValid: true };
    }
    const handleClose = () => {
        setPopup(false);
        if (pageType === "Listing") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (popupType !== "Delete") {
            // setStates({ selectedRowKeys: [] })
        }
    }
    const getAnnualRevenueData = async () => {
        try {
            const data = await getAnnualRevenue()
            const options = data.map((option, i) => (
                <Option value={option.annualRevenue} key={i}>
                    {option.annualRevenue}
                </Option>));
            setRevenue(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getRatingData = async () => {
        try {
            const data = await getRating()
            const options = data.map((option, i) => (
                <Option value={option.rating} key={i}>
                    {option.rating}
                </Option>));
            SetRating(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getTitleData = async () => {
        try {
            const data = await getTitle()
            const options = data.map((option, i) => (
                <Option value={option.title} key={i}>
                    {option.title}
                </Option>));
            setTitle(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            const options = response.map((option) => (
                <Option key={option.countryId} value={option.country}>
                    {option.country}
                </Option>))
            setAllCountry(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const HandleIsModalVisible = (value) => {
        setIsModalVisible(value)
        setPopup(false)
    }
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        if (popupType.includes("Delete")) {
            const payload = {
                leadIds: values
            }
            try {
                const response = await massDeleteLeads(payload)
                if (response.status === 200) {
                    if (popupType === "Delete") {
                        if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                            setErrorData(response.data);
                            setIsModalVisible(true);
                            dispatch(setEditCall(false))
                            loadingRef.current = false;
                            setDelteClick(false)
                        } else {
                            const isAutomation = response.data[0].entityMessage === AutomationMessage;
                            const isApproval = response.data[0].entityMessage === ApprovalMessage;
                            loadingRef.current = false;
                            setDelteClick(false)
                            dispatch(setEditCall(false))
                            if (isApproval) {
                                successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            } else if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].entityMessage);
                            } else {
                                message.success(
                                    <span>
                                        Lead <strong>{response?.data?.[0]?.entityName}</strong> has been deleted successfully
                                    </span>
                                );
                            }
                            history.push('/Home/leads')
                            setPopup(false)
                        }
                    } else {
                        const allUpdatedSuccessfully = response.data.every(item =>
                            item.entityMessage === "Lead Has Deleted Successfully"
                        );
                        if (allUpdatedSuccessfully) {
                            dispatch(setEditCall(false))
                            message.success(`${values.length} record${values.length > 1 ? "s" : ""} deleted successfully`);
                            GetAll();
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                            setPopup(false)
                            loadingRef.current = false;
                            setDelteClick(false)
                            return;
                        }
                        loadingRef.current = false;
                        setDelteClick(false)
                        dispatch(setEditCall(false))
                        setErrorData(response.data);
                        setIsModalVisible(true);
                    }
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                message.error(error)
            }
        }
        else {
            const payload =
            {
                leads: values
            }
            try {
                const response = await convertLeadToContact(payload);
                if (response.status === 201) {
                    setTimeout(() => {
                        FetchAllAccount()
                    }, 1000);
                    if (response.data.success.length > 0 && response.data.error.length === 0) {
                        if (action === "ConvertNav") {
                            dispatch(setExPoCall(true))
                            successMessage('Lead converted to contact',
                                <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Party.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span>
                                        Congratulations! Your lead, <strong>{response.data.success}</strong>, has been converted into a contact. You&lsquo;re one step closer to closing the deal!
                                    </span>
                                </>)
                            setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            setPopup(false);
                            loadingRef.current = false;
                            setDelteClick(false)
                            history.push('/Home/leads');
                            // message.success(`${response.data.success} has been converted to a contact`)
                        }
                        else {
                            GetAll();
                            loadingRef.current = false;
                            setDelteClick(false)
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                            setPopup(false);
                            dispatch(setExPoCall(true));
                            successMessage("Leads converted to contacts",
                                <>
                                    <img
                                        src={require('../../../static/img/defaultImages/Party.gif')}
                                        alt="celebration"
                                        style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                    />
                                    <span> Congratulations! Your selected leads have been converted into contacts. You&lsquo;re one step closer to closing the deal!</span>
                                </>)
                            setTimeout(() => dispatch(setExPoCall(false)), 3000);
                            // message.success("Selected leads have been successfully converted to contacts")
                        }
                    }
                    else if (response.data.success.length > 0 && response.data.error.length > 0) {
                        dispatch(setExPoCall(true));
                        loadingRef.current = false;
                        setDelteClick(false)
                        successMessage("Leads converted to contacts",
                            <>
                                <img
                                    src={require('../../../static/img/defaultImages/Party.gif')}
                                    alt="celebration"
                                    style={{ width: '100px', display: 'block', margin: '0 auto 15px' }}
                                />
                                <span> Congratulations! Your selected leads have been converted into contacts. You&lsquo;re one step closer to closing the deal!</span>
                            </>)
                        setTimeout(() => dispatch(setExPoCall(false)), 3000);
                        // message.info("Selected leads have been successfully converted to contacts")
                        setOpen(false)
                        // setOpen(true)
                        GetAll();
                    }
                    // else if (response.data.success.length === 0 && response.data.error.length > 0) {
                    //     message.error("No leads with qualified accounts found")
                    //     setOpen(true)
                    //     GetAll();
                    // }
                    else {
                        loadingRef.current = false;
                        setDelteClick(false)
                        GetAll();
                        setPopup(false);
                        message.error("Issue with converting")
                        // message.info("No leads with qualified accounts found")
                    }
                    // setData(response.data)
                    dispatch(setEditCall(false))
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                message.error(error)
            }
        }
    }
    const handleChangeField = (value) => {
        setFieldValue(value)
    }
    const onFromSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        // const { firstName, description, lastName, postcode, street, accountName, leadOwner, title, primaryEmail, phone, fax, mobile, leadSource, leadStatus, secondaryEmail } = value;
        const formData = {
            leadIds: values,
        }
        if (popupType === "Change Owner") {
            if (fieldValue === 1) {
                formData.leadOwner = field1;
            }
            const isAnyFieldUndefined = Object.values(formData).some(value => value === undefined);
            if (!isAnyFieldUndefined) {
                try {
                    const response = await massUpdateLead(formData)
                    if (response.status === 200) {
                        if (action === "SingleChangeOwner") {
                            if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                                setErrorData(response.data);
                                setIsModalVisible1(true);
                                dispatch(setEditCall(false))
                                loadingRef.current = false;
                                setDelteClick(false)
                            }
                            else {
                                const isAutomation = response.data[0].message === AutomationMessage;
                                const isApproval = response.data[0].message === ApprovalMessage;
                                loadingRef.current = false;
                                setDelteClick(false)
                                dispatch(setEditCall(false))
                                if (isApproval) {
                                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                                } else if (isAutomation) {
                                    successMessage("Automation rule triggered", response.data[0].message);
                                } else {
                                    message.success(
                                        <span>
                                            Lead <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                        </span>
                                    );
                                }
                                setPopup(false)
                                if (!isApproval && assignOwner !== field1) {
                                    history.push('/Home/leads');
                                }
                                if (assignOwner === field1) {
                                    GetAll()
                                }
                            }
                        }
                        else {
                            const allUpdatedSuccessfully = response.data.every(item =>
                                item.message === "Lead Has Updated Successfully"
                            );
                            if (allUpdatedSuccessfully) {
                                loadingRef.current = false;
                                setDelteClick(false)
                                dispatch(setEditCall(false))
                                if (pageType === "Listing") {
                                    setStates({
                                        selectedRows: [],
                                        selectedRowKeys: [],
                                    })
                                }
                                message.success("Data updated for selected records")
                                GetAll()
                                setPopup(false)
                                return;
                            }
                            loadingRef.current = false;
                            setDelteClick(false)
                            setErrorData(response.data);
                            setIsModalVisible1(true);
                            dispatch(setEditCall(false))
                        }
                    }
                }
                catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    message.error(error)
                }
            } else {
                message.error("Field is Empty");
            }
        }
        if (popupType === "Bulk Update") {
            const validation = RequiredValidity(selectBoxes);
            if (!validation.isValid) {
                message.error(validation.message);
                loadingRef.current = false;
                setDelteClick(false)
                return;
            }
            if (validateQueryData(selectBoxes)) {
                const flatFields = selectBoxes.reduce((acc, item) => {
                    const { editedField, editedValue, visible } = item;
                    if (!editedField) return acc;
                    if (editedField === "tags") {
                        acc[editedField] = tagType === "Clear" ? null : normalizeValue(editedValue);
                        acc.actionType = tagType;
                        return acc;
                    }
                    const normalizedValue = normalizeValue(editedValue);
                    if (visible === "No") {
                        acc[editedField] = normalizedValue;
                        return acc;
                    }
                    if (editedValue != null) {
                        acc[editedField] = normalizedValue;
                    }
                    return acc;
                }, {});
                Object.assign(formData, flatFields);
                try {
                    const response = await massUpdateLead(formData)
                    if (response.status === 200) {
                        const allUpdatedSuccessfully = response.data.every(item =>
                            item.message === "Lead Has Updated Successfully"
                        );
                        if (allUpdatedSuccessfully) {
                            loadingRef.current = false;
                            setDelteClick(false)
                            dispatch(setEditCall(false))
                            if (pageType === "Listing") {
                                setStates({
                                    selectedRows: [],
                                    selectedRowKeys: [],
                                })
                            }
                            message.success("Data updated for selected records")
                            GetAll()
                            setPopup(false)
                            return;
                        }
                        loadingRef.current = false;
                        setDelteClick(false)
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        dispatch(setEditCall(false))
                    }
                }
                catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    message.error(error)
                }
            }
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            setUsers(data)
        } catch (error) {
            message.error(error)
        }
    }
    const getNomEmployeeData = async () => {
        try {
            const data = await getNoofEmployee()
            const options = data.map((option, i) => (
                <Option value={option.nomOfEmployee} key={i}>
                    {option.nomOfEmployee}
                </Option>));
            setNoofemployee(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AllIndustry() {
        try {
            const data = await IndustryData()
            setIndustryData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getLeadsource = async () => {
        try {
            const data = await getLeadsourceData()
            setLeadSource(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getLeadStatus = async () => {
        try {
            const data = await getLeadStatusData()
            setLeadStatus(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getSeniorityLevel = async () => {
        try {
            const data = await getSeniorityLevelData()
            const options = data.map((option, i) => (
                <Option value={option.seniorityLevelId} key={i}>
                    {option.seniorityLevel}
                </Option>));
            setSeniority(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function Triggerfields() {
        try {
            const response = await getTriggerFiledforEntity("Lead")
            const removeFields = ["firstName", "lastName", "primaryEmail"];
            const filteredAttributes = response?.filter((item) => item.filedValue !== "description").filter(
                item => !removeFields.includes(item.filedValue)
            );
            setEditAttributes(filteredAttributes)
        } catch (error) {
            message.error(error)
        }
    }
    async function fetchLeadAndAccount() {
        try {
            // Run both requests in parallel
            const [leads, accounts] = await Promise.all([
                FetchAllLead(),
                FetchAllAccount()
            ]);

            return { leads, accounts };
        } catch (error) {
            message.error(error);
            throw error; // rethrow so caller knows it failed
        }
    }
    async function LeadApi() {
        try {
            const { leads, accounts } = await fetchLeadAndAccount();
            const leadAccounts = leads?.items.map(item => ({
                value: item.account_name,
                key: item.account_name,
            }));
            const apiAccounts = accounts.map(item => ({
                value: item.account_name,
                key: item.account_name,
            }));
            const mergedAccounts = Array.from(
                new Map(
                    [...leadAccounts, ...apiAccounts].map(item => [item.value, item])
                ).values()
            );
            setAccount2(mergedAccounts)
        } catch (error) {
            message.error(error)
        }
    }

    const getUserDetail = async () => {
        if (action === "SingleChangeOwner") {
            setField1(assignOwner)
            form.setFieldsValue({
                leadOwner: assignOwner
            });
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (profile.department === "Sales") {
                setField1(profile.userId)
                form.setFieldsValue({
                    leadOwner: profile.userId
                });
            }
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            LeadApi(),
            getCountry(),
            getSeniorityLevel(),
            Triggerfields(),
            getRatingData(),
            getAnnualRevenueData(),
            getNomEmployeeData(),
            getTitleData(),
            UserDetailsApi(),
            AllIndustry(),
            getLeadsource(),
            getLeadStatus(),
        ])
        setUiReady(true)
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            getUserDetail()
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (popup) {
            if (popupType === "Bulk Update") {
                fetchAll()
            }
            else if (popupType === "Change Owner") {
                fetchAll1()
            }
            else {
                setUiReady(true)
            }
        }
    }, [popup])
    const handleLeadOwner = (value) => {
        setField1(value)
    }
    const getRefreshtheTable = () => {
        setPopup(false)
        if (pageType === "Listing") {
            GetAll();
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (action === "DeleteNav") {
            history.push('/Home/leads')
        }
    }
    // const getFieldIndex = (formData, fieldName) => {
    //     return formData.find(item => item.editedField === fieldName);
    // };
    const handleViewChange = async (index, fieldName, value, key, currecnyData, option) => {
        if (fieldName === "editedField" && value === "tags") {
            setTagType("Add")
        }
        let updatedFormData = [...selectBoxes];
        if (fieldName === "editedField") {
            updatedFormData[index] = {
                ...updatedFormData[index],
                editedField: normalizeValue(value),
                editedValue: null,
                Key: key,
                Currency: currecnyData
            };
            if (normalizeValue(value) === "country" || normalizeValue(value) === "state" || normalizeValue(value) === "city" || normalizeValue(value) === "street" || normalizeValue(value) === "postcode") {
                const countryField = {
                    editedField: "country",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const stateField = {
                    editedField: "state",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const cityField = {
                    editedField: "city",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const streetField = {
                    editedField: "street",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                if (normalizeValue(value) === "country") {
                    updatedFormData = updatedFormData.map(item =>
                        (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode")
                            ? {
                                ...item, editedField: item.editedField, editedValue: null
                            }
                            : item
                    );
                    setStateData([])
                    setCityData([])
                }
                if (normalizeValue(value) === "state") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== 'city' && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    updatedFormData.splice(index, 0, countryField);

                    setStateData([])
                    setCityData([])
                }
                if (normalizeValue(value) === "city") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField);
                }
                if (normalizeValue(value) === "street") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "postcode"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField);
                }
                if (normalizeValue(value) === "postcode") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField, streetField);
                }
            } else {
                updatedFormData = updatedFormData.filter(
                    item => !["country", "state", "city", "street", "postcode"].includes(item.editedField)
                );
            }
        }
        else {
            const editedFieldType = updatedFormData[index]?.editedField;
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                Key: key
            };
            if (editedFieldType === "country") {
                try {
                    const response = await getStateData(option.key)
                    setStateData(response)
                    setCityData([])
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "state"
                    );
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "state") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "state",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    setStateData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "state") {
                try {
                    const response = await getCityData(option.key)
                    setCityData(response)
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "city") {
                try {
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
            else if (editedFieldType === "street") {
                try {
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
        }
        setSelectBoxes(updatedFormData);
    };
    const getAvailableOptions = (currentIndex) => {
        const selectedValues = selectBoxes.filter(box => box.visible !== "No").map(box => box.editedField).filter(value => value !== undefined);
        return editAttributes.filter(option => !selectedValues.includes(option.filedValue) || selectBoxes[currentIndex].editedField === option.filedValue);
    };
    function getFieldTypeByValue(fieldValue) {
        const field = editAttributes.find(item => item.filedValue === fieldValue);
        return field ? field.FieldType : null;
    }
    const segBtn1 = (active) => ({ flex: 1, padding: "7px 0", fontSize: 12.5, fontWeight: 600, cursor: "pointer", borderRadius: 6, color: active ? "#407fe9" : "#8f8f8f", border: "none", background: active ? "white" : "transparent", });
    return (
        <>
            <Modal
                title={popupType}
                open={popup}
                onCancel={handleClose}
                // width={700}
                maskClosable={false}
                footer={uiReady ? [
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        {popupType === "Bulk Update" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button className='btn-add_new button_colors' size="small" onClick={onFromSubmit} loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <SaveIcon />}Update
                                </Button>
                            </>
                        }
                        {popupType === "Change Owner" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button htmlType="submit" size="small" className='btn-add_new button_colors' onClick={onFromSubmit} loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <ChangeOwnerIcon />}Change Owner
                                </Button>
                            </>
                        }
                        {(popupType === "Bulk Delete" || popupType === "Bulk Convert" || popupType === "Delete" || popupType === "Convert") &&
                            <>
                                {!open ?
                                    <>
                                        <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                            <CancelIcon /> Cancel
                                        </Button>
                                        <Button htmlType="submit" size="small" onClick={onSubmit} loading={deleteClick} disabled={deleteClick} className={popupType === "Bulk Convert" || popupType === "Convert" ? "button_colors" : "red-button"}>
                                            {!deleteClick && (popupType === "Bulk Convert" || popupType === "Convert" ? <ConvertIcon /> : <DeleteIcon />)}{popupType}
                                        </Button>
                                    </>
                                    :
                                    <>
                                        <Button htmlType="submit" size="small" className='button_colors' onClick={handleClose}>
                                            Ok
                                        </Button>
                                    </>}
                            </>}
                    </div>
                ] : false}
            >
                {uiReady ? <> {popupType === "Bulk Update" &&
                    (editAttributes.length > 0 ? <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="LeadMassUpdate" >
                                    {selectBoxes.filter((item) => item?.visible !== "No").map((selectbox, index) => {
                                        const filedType = getFieldTypeByValue(selectbox.editedField)
                                        return (
                                            <>
                                                <div style={{ padding: "0px 20px", display: selectbox.editedField !== 'tags' && "none" }}>
                                                    <div style={{ display: "flex", gap: 4, background: "#f7f7f7", borderRadius: 8, padding: 5, marginBottom: "0px 0px 20px" }}>
                                                        <button type="button" style={segBtn1(tagType === "Add")} onClick={() => setTagType("Add")}>Add tag</button>
                                                        <button type="button" style={segBtn1(tagType === "Remove")} onClick={() => setTagType("Remove")}>Remove tag</button>
                                                        <button type="button" style={segBtn1(tagType === "Clear")} onClick={() => {
                                                            setTagType("Clear");
                                                            setSelectBoxes(prev =>
                                                                prev.map(item =>
                                                                    item.editedField === "tags"
                                                                        ? { ...item, editedValue: "" }
                                                                        : item
                                                                )
                                                            );
                                                        }}>Clear all</button>
                                                    </div>
                                                </div>
                                                <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                                    <Col span={10}>
                                                        <Form.Item >
                                                            <Select style={{ width: '100%' }}
                                                                placeholder="Select Field"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                value={selectbox.editedField}
                                                                onChange={(record, option) => {
                                                                    const Key = option.FieldType
                                                                    const currecnyData = option.FieldData
                                                                    handleViewChange(index, 'editedField', record, Key, currecnyData);
                                                                }}
                                                                disabled={index !== 0}
                                                            >
                                                                {getAvailableOptions(index).map((option, idx) => (
                                                                    <Option value={option.filedValue} key={idx} FieldType={option.FieldType} FieldData={option.currencyType}>
                                                                        {option.fieldLable}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={14}>
                                                        <Form.Item key={index}>
                                                            {selectbox.editedField === 'tags' ?
                                                                <Select open={false}
                                                                    className="lead-tags-input"
                                                                    mode="tags" disabled={tagType === "Clear"}
                                                                    style={{ width: "100%" }}
                                                                    placeholder="Enter tags"
                                                                    tokenSeparators={[","]}
                                                                    value={selectbox.editedValue ? selectbox.editedValue.split(",").map((tag) => tag.trim()).filter(Boolean) : []}
                                                                    onChange={(value, option) => {
                                                                        handleViewChange(index, 'editedValue', value?.join(",") || "", filedType, selectbox.Currency, option);
                                                                    }}
                                                                />
                                                                : filedType === 'Drop Down' ? (
                                                                    selectbox.editedField === "accountName" ?
                                                                        <AutoComplete
                                                                            options={account2}
                                                                            value={selectbox.editedValue}
                                                                            onSelect={(value) => handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency)}
                                                                            onChange={(value) => handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency)}
                                                                            style={{ width: '100%' }}
                                                                            placeholder="Type or select an option"
                                                                            filterOption={(inputValue, option) =>
                                                                                option.value.toLowerCase().includes(inputValue.toLowerCase())
                                                                            }
                                                                        >
                                                                            <Input />
                                                                        </AutoComplete>
                                                                        : <Select placeholder="Select Value"
                                                                            showSearch
                                                                            style={{ width: "100%" }}
                                                                            optionFilterProp="children"
                                                                            {...(selectbox.editedField === "leadOwner"
                                                                                ? { optionLabelProp: "label" } : {})}
                                                                            filterOption={(input, option) =>
                                                                                (selectbox.editedField === "leadOwner")
                                                                                    ? (() => {
                                                                                        const usernameElement = option.children.props.children[1].props.children[0];
                                                                                        if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                            const username = String(usernameElement.props.children);
                                                                                            return username.toLowerCase().includes(input.toLowerCase());
                                                                                        }
                                                                                        return false;
                                                                                    })()
                                                                                    : option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            }
                                                                            name="editedValue"
                                                                            value={selectbox.editedValue}
                                                                            onChange={(value, option) => {
                                                                                handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency, option);
                                                                            }}
                                                                        >
                                                                            {(selectbox.editedField === "leadOwner") &&
                                                                                users.filter(item => item.department === "Sales").map((option, i) => (
                                                                                    <Option value={option.userId}
                                                                                        label={(
                                                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                                <div className='Div_flex2'>
                                                                                                    <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                                        {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                            < img src={option.profilePic} alt="profile" />
                                                                                                            :
                                                                                                            <span className="image_icon UserIcon">
                                                                                                                {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                            </span>
                                                                                                        }
                                                                                                        <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                        key={i}>
                                                                                        <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                                            <div>
                                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                    < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                    :
                                                                                                    <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                    </span>
                                                                                                }</div>
                                                                                            <div>
                                                                                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                                <p style={{ margin: 0 }}>{option.username}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Option>))
                                                                            }
                                                                            {(selectbox.editedField === "emailOtpOut" || selectbox.editedField === "emailOptOut") && <>
                                                                                <Option value>Yes</Option>
                                                                                <Option value={false}>No</Option>
                                                                            </>}
                                                                            {selectbox.editedField === "seniorityLevelId" && <>
                                                                                {seniority}
                                                                            </>}
                                                                            {selectbox.editedField === "title" && <>
                                                                                {title}
                                                                            </>}
                                                                            {(selectbox.editedField === "leadSourceId") &&
                                                                                leadsource.map((option) => (
                                                                                    <Option value={option.leadSourceId} key={option.id}>
                                                                                        {option.leadSourceName}
                                                                                    </Option>))}
                                                                            {selectbox.editedField === "leadStatusId" &&
                                                                                leadStatus.map((option) => (
                                                                                    <Option value={option.leadStatusId} key={option.id}>
                                                                                        {option.leadStatusName}
                                                                                    </Option>))}
                                                                            {selectbox.editedField === "industry" &&
                                                                                industryData.map((option, i) => (
                                                                                    <Option value={option.industryId} key={i}>
                                                                                        {option.industryName}
                                                                                    </Option>))}
                                                                            {selectbox.editedField === "country" &&
                                                                                <>
                                                                                    {allCountry}
                                                                                </>}
                                                                            {selectbox.editedField === "state" &&
                                                                                <>
                                                                                    {stateData?.map((option) => (
                                                                                        <Option key={option.stateId} value={option.state}>
                                                                                            {option.state}
                                                                                        </Option>
                                                                                    ))}
                                                                                </>}
                                                                            {selectbox.editedField === "city" &&
                                                                                <>
                                                                                    {cityData?.map((option) => (
                                                                                        <Option key={option.cityId} value={option.city}>
                                                                                            {option.city}
                                                                                        </Option>
                                                                                    ))}
                                                                                </>}
                                                                            {selectbox.editedField === "annualRevenue" &&
                                                                                <>
                                                                                    {revenue}
                                                                                </>}
                                                                            {selectbox.editedField === "nomOfEmployees" &&
                                                                                <>
                                                                                    {noofemployee}
                                                                                </>}
                                                                            {selectbox.editedField === "rating" &&
                                                                                <>
                                                                                    {rating}
                                                                                </>}

                                                                        </Select>
                                                                ) : filedType === 'Boolean' ?
                                                                    <Select placeholder="Select Value"
                                                                        showSearch
                                                                        style={{ width: "100%" }}
                                                                        optionFilterProp="children"
                                                                        name="editedValue"
                                                                        value={selectbox.editedValue}
                                                                        onChange={(value) => {
                                                                            handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency);
                                                                        }}
                                                                    >
                                                                        {(selectbox.editedField === "resell" || selectbox.editedField === "emailOtpOut" || selectbox.editedField === "emailOptOut") && <>
                                                                            <Option value>Yes</Option>
                                                                            <Option value={false}>No</Option>
                                                                        </>}
                                                                    </Select>
                                                                    : filedType === 'Free Text' || filedType === 'Numbers' ? (
                                                                        (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                            name="editedValue"
                                                                            value={selectbox.editedValue}
                                                                            onChange={(e) => {
                                                                                const inputValue = e.target.value;
                                                                                const TotalLength = selectbox.editedField  === "street" ? 100 : 50
                                                                                if (inputValue?.toString()?.length > TotalLength) {
                                                                                    message.error(`Maximum ${TotalLength} characters allowed`);
                                                                                    return;
                                                                                }
                                                                                handleViewChange(index, 'editedValue', inputValue, filedType, selectbox.Currency);
                                                                            }} />
                                                                        ))
                                                                        : ""
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    })}
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser> :
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "120px" }}>
                            <Spin />
                        </div>)
                }
                    {popupType === "Change Owner" &&
                        <AddUser>
                            <div className="user-info-form">
                                <BasicFormWrapper>
                                    <Form style={{ width: '100%' }} form={form} name="Assignto" >
                                        <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                            <Col span={10}>
                                                <Form.Item>
                                                    <Select style={{ width: '100%' }}
                                                        placeholder="Select Field"
                                                        showSearch
                                                        disabled
                                                        optionFilterProp="children"
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        value={fieldValue}
                                                        onChange={handleChangeField}
                                                    >
                                                        {Data.Leads !== undefined && Data.Leads?.map((option, key) => (
                                                            <Option key={key} value={option.id}>
                                                                {option.filed}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={14}>
                                                {fieldValue === 1 &&
                                                    <Form.Item name="leadOwner" id="leadOwner">
                                                        <Select style={{ width: '100%' }}
                                                            placeholder="Select Lead Owner"
                                                            showSearch optionLabelProp="label"
                                                            filterOption={(input, option) => {
                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                    const username = String(usernameElement.props.children);
                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                }
                                                                return false;
                                                            }
                                                            }
                                                            onChange={handleLeadOwner}>
                                                            {users.filter(item => item.department === "Sales").map((option, i) => (
                                                                <Option value={option.userId}
                                                                    label={(
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <div className='Div_flex2'>
                                                                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                        < img src={option.profilePic} alt="profile" />
                                                                                        :
                                                                                        <span className="image_icon UserIcon">
                                                                                            {option.firstName.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }
                                                                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    key={i}>
                                                                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`} >
                                                                        <div>
                                                                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                :
                                                                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                    {option.firstName.slice(0, 1).toUpperCase()}
                                                                                </span>
                                                                            }</div>
                                                                        <div>
                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                            <p style={{ margin: 0 }}>{option.username}</p>
                                                                        </div>
                                                                    </div>
                                                                </Option>))}
                                                        </Select>
                                                    </Form.Item>}
                                            </Col>
                                        </Row>
                                    </Form>
                                </BasicFormWrapper>
                            </div>
                        </AddUser>
                    }
                    {(popupType === "Bulk Delete" || popupType === "Bulk Convert" || popupType === "Delete" || popupType === "Convert") &&
                        <div style={{ padding: "0px 20px" }}>
                            {!open ?
                                <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                    {popupType === "Bulk Delete" && <p>Are you sure you want to delete the selected leads?</p>}
                                    {popupType === "Bulk Convert" && <p>Are you sure you want to convert the selected leads into contacts?</p>}
                                    {popupType === "Delete" && <p>Are you sure you want to delete?</p>}
                                    {popupType === "Convert" && <p> Are you sure you want to convert this lead into a contact?</p>}
                                </div>
                                : <></>
                                // <>
                                //     {data !== undefined && data.success.length !== 0 &&
                                //         <div style={{ marginBottom: 30 }}>
                                //             success Datas:
                                //             {data.success.slice(0, itemsToShow).map((item, index) => (
                                //                 <div key={index}>{item}</div>
                                //             ))}
                                //             {data.success.length > initialItemsToShow && !show && (
                                //                 <span
                                //                     style={{ cursor: 'pointer', color: 'blue' }}
                                //                     role="button"
                                //                     tabIndex={0}
                                //                     onClick={() => setShow(true)}
                                //                     onKeyDown={(e) => {
                                //                         if (e.key === 'Enter' || e.key === ' ') {
                                //                             setShow(!showAll);
                                //                         }
                                //                     }}>
                                //                     View More...
                                //                 </span>
                                //             )}
                                //         </div>}
                                //     {data !== undefined && data.error.length !== 0 &&
                                //         <div>
                                //             Failed Datas:
                                //             {data.error.slice(0, itemsToShowAll).map((item, index) => (
                                //                 <div key={index}>{item}</div>
                                //             ))}
                                //             {data.error.length > initialItemsToShowAll && !showAll && (
                                //                 <span
                                //                     style={{ cursor: 'pointer', color: 'blue' }}
                                //                     role="button"
                                //                     tabIndex={0}
                                //                     onClick={() => setShowAll(true)}
                                //                     onKeyDown={(e) => {
                                //                         if (e.key === 'Enter' || e.key === ' ') {
                                //                             setShowAll(!showAll);
                                //                         }
                                //                     }}>
                                //                     View More...
                                //                 </span>
                                //             )}
                                //         </div>}
                                // </>
                            }
                        </div>}</> :
                    <div className="spin" style={{ height: "250px" }}>
                        <Spin />
                    </div>}
            </Modal>
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page={pageType === "Listing" ? "DetailsError" : "Details"} type="Lead" getCallBack={getRefreshtheTable} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page={popupType === "Bulk Delete" ? "DetailsError" : "Details"} type="Lead" getCallBack={getRefreshtheTable} />}
        </>
    );
};

Popup.propTypes = {
    popup: PropTypes.bool.isRequired,
    setPopup: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
    action: PropTypes.string.isRequired,
    setStates: PropTypes.func.isRequired,
    assignOwner: PropTypes.number.isRequired,
    pageType: PropTypes.string.isRequired,
    successMessage: PropTypes.func.isRequired,
};

export default Popup;
